import React, { useState, useEffect } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "./Countdown.css";

const Countdown = ({
  completionPercent,
  setStarted,
  displayError,
  setShowPopup,
  setPopupType,
}) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [hoursLeft, setHoursLeft] = useState("");
  const [minutesLeft, setminutesLeft] = useState("");
  const [secondsLeft, setsecondsLeft] = useState("");
  const allDebtsPaid = completionPercent === 1.0;

  useEffect(() => {
    const timer = setInterval(() => {
      // Get the current date in MST
      const now = new Date();
      const mstDate = new Date(
        now.toLocaleString("en-US", { timeZone: "America/Denver" })
      );

      // Calculate time remaining until the next MST midnight
      const midnightMST = new Date(mstDate);
      midnightMST.setHours(24, 0, 0, 0);
      const timeRemaining = midnightMST.getTime() - mstDate.getTime();

      // Update the time left
      const hoursLeft = Math.floor(
        (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutesLeft = Math.floor(
        (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
      );
      const secondsLeft = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      setTimeLeft(
        `${String(hoursLeft).padStart(2, "0")}:${String(minutesLeft).padStart(
          2,
          "0"
        )}:${String(secondsLeft).padStart(2, "0")}`
      );

      setHoursLeft(`${String(hoursLeft)}`);
      setminutesLeft(`${String(minutesLeft)}`);
      setsecondsLeft(`${String(secondsLeft)}`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  //delays Title Button to resolve flashing font error, plus looks cool.
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Set a timer to change visibility after 1 second
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 900); // 1/20 second delay

    // Clean up the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="timeleft"
      style={{
        opacity: isVisible ? 1 : 0,
        transition: "opacity 1s",
      }}
    >
      {allDebtsPaid && displayError === "" ? (
        <>
          <div style={{ fontWeight: "bold" }}>THE DRAGON IS PLEASED</div>
          <br></br>
          {timeLeft && (
            <>
              {`you earned guilt-free free time for `}
              <br></br>

              {`${hoursLeft} h, ${minutesLeft} m, and ${secondsLeft} s`}
            </>
          )}
        </>
      ) : timeLeft ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>time remaining: {timeLeft} </div>
          <InfoOutlinedIcon
            style={{ fontSize: "20px" }}
            onClick={() => {
              setShowPopup(true);
              setPopupType("countdownInfo");
            }}
          />
        </div>
      ) : (
        "counting down..."
      )}
      {timeLeft === "00:00:00" && setStarted(false)}
    </div>
  );
};

export default Countdown;
